<div class="flex flex-col lg:flex-row flex-grow">
  <div class="p-8 lg:p-28 lg:pt-32 pb-0 md:py-14 md:mb-8 lg:mb-0 md:bg-white relative lg:max-w-4xl lg:w-full">
    <h2
      class="
        z-10
        relative
        text-5xl
        mb-4
        md:mb-0 md:mx-auto md:max-w-5xl
        text-center
        lg:text-left
        te-text-gradient
        font-normal
        lg:mb-16
      "
    >
      {{ 'modules.evcSmallBiz.finalInvoice.pageTitle' | translate }}
    </h2>
    <!-- <article class="hidden lg:block bg-grey-light border rounded-lg border-grey p-8 mb-8">
      <div class="mb-6">
        {{ "modules.evcSmallBiz.finalInvoice.review.content" | translate }}
      </div>
      <div class="flex flex-row items-center">
        <img src="./assets/evc/img/reviewer-img.png" alt="reviewer" class="rounded-full w-20 h-20 mr-4" />
        <div>
          <div class="text-sm font-bold">{{ "modules.evcSmallBiz.finalInvoice.review.name" | translate }}</div>
          <div class="body-mention">{{ "modules.evcSmallBiz.finalInvoice.review.role" | translate }}</div>
        </div>
      </div>
    </article>
    <div class="hidden lg:block mb-8">
      <div class="flex justify-center mb-2">
        <svg-icon src="./assets/evc/img/star.svg" class="text-appleblue" *ngFor="let i of [1, 2, 3, 4, 5]"></svg-icon>
      </div>
      <div class="body-mention text-center text-grey-dark60">
        {{ "modules.evcSmallBiz.finalInvoice.virtualCheckup.rating" | translate }}
      </div>
    </div> -->
  </div>
  <div
    class="p-8 lg:pt-32 container flex justify-center mx-auto max-w-7xl xl:max-w-screen-xl w-full"
    *ngIf="model$ | async as model"
  >
    <div class="flex flex-col lg:max-w-3xl">
      <evsb-card [variant]="'turquoise'" class="mb-12 w-full">
        <evsb-card-header-image
          [variant]="'turquoise'"
          [label]="'modules.evcSmallBiz.finalInvoice.virtualCheckup.title' | translate"
          [imgSrc]="'./assets/evsb/img/support-chat.svg'"
        >
        </evsb-card-header-image>
        <evsb-card-body class="border-b border-grey block">
          <ul class="list-checkmark space-y-2">
            <li
              class="mb-3"
              [innerHtml]="'modules.evcSmallBiz.finalInvoice.virtualCheckup.point1.title' | translate"
            ></li>
            <li
              class="mb-3"
              [innerHtml]="'modules.evcSmallBiz.finalInvoice.virtualCheckup.point2.title' | translate"
            ></li>
            <li
              class="mb-3"
              [innerHtml]="'modules.evcSmallBiz.finalInvoice.virtualCheckup.point3.title' | translate"
            ></li>
          </ul>
          <footer class="border-t border-grey-100 mt-5 pt-5">
            <evsb-details label="Details">
              <div heading class="h4">
                {{ 'modules.evcSmallBiz.finalInvoice.virtualCheckup.freeService' | translate }}
              </div>
              <section class="mt-4">
                <evsb-nav-tabs>
                  <evsb-nav-tab [title]="'modules.evcSmallBiz.finalInvoice.virtualCheckup.tab1.title' | translate">
                    <p class="text-grey-dark text-xs antialiased">
                      {{ 'modules.evcSmallBiz.finalInvoice.virtualCheckup.tab1.description' | translate }}
                    </p>
                  </evsb-nav-tab>
                  <evsb-nav-tab [title]="'modules.evcSmallBiz.finalInvoice.virtualCheckup.tab2.title' | translate">
                    <p class="text-grey-dark text-xs antialiased">
                      {{ 'modules.evcSmallBiz.finalInvoice.virtualCheckup.tab2.description' | translate }}
                    </p>
                  </evsb-nav-tab>
                  <evsb-nav-tab [title]="'modules.evcSmallBiz.finalInvoice.virtualCheckup.tab3.title' | translate">
                    <p class="text-grey-dark text-xs antialiased">
                      {{ 'modules.evcSmallBiz.finalInvoice.virtualCheckup.tab3.description' | translate }}
                    </p>
                  </evsb-nav-tab>
                </evsb-nav-tabs>
              </section>
            </evsb-details>
          </footer>
        </evsb-card-body>
      </evsb-card>

      <div class="mb-8">
        <div class="flex justify-center mb-2">
          <svg-icon src="./assets/evc/img/star.svg" class="text-appleblue" *ngFor="let i of [1, 2, 3, 4, 5]"></svg-icon>
        </div>
        <div class="body-mention text-center text-grey-dark60">
          {{ 'modules.evcSmallBiz.finalInvoice.virtualCheckup.rating' | translate }}
        </div>
      </div>

      <evsb-card [variant]="'blue'" class="mb-12 w-full">
        <evsb-card-header [variant]="'blue'" [label]="'modules.evcSmallBiz.finalInvoice.solution.title' | translate">
          <div class="flex items-center h-full">
            <svg-icon
              src="./assets/evsb/icon/edit.svg"
              role="button"
              title="edit"
              class="text-white"
              (click)="editSolution()"
            ></svg-icon>
          </div>
        </evsb-card-header>
        <evsb-smooth-height [trigger]="model.chargeCard">
          <evsb-card-body>
            <evsb-details *ngIf="model.chargeCard" [label]="'Details'">
              <div heading class="flex mb-4">
                <evsb-currency-sm
                  [imgSrc]="'./assets/evsb/img/charing-card-circle.png'"
                  [amount]="model.chargeCardPrice"
                  [end]="'modules.evcSmallBiz.finalInvoice.chargeCard.amountEnd' | translate"
                >
                </evsb-currency-sm>
              </div>
              <div class="mb-8">
                <evsb-price-list-entry
                  *ngFor="let item of model.chargeCardItems"
                  [price]="item.price"
                  [count]="item.count"
                  [label]="item.label | translate"
                  [description]="item.description | translate"
                  [bottomLabel]="
                    item.bottomLabel + ('modules.evcSmallBiz.finalInvoice.chargeCard.amountEnd' | translate)
                  "
                ></evsb-price-list-entry>
              </div>
            </evsb-details>

            <evsb-details *ngIf="model.chargePoint" [label]="'Details'">
              <div class="flex" heading>
                <evsb-currency-sm
                  [imgSrc]="'./assets/evc/img/charger-circle.png'"
                  [amount]="model.chargePointPrice"
                  [end]="'modules.evcSmallBiz.finalInvoice.chargePoint.amountEnd' | translate"
                ></evsb-currency-sm>
              </div>
              <div class="mt-4 mb-4">
                <evsb-price-list-entry
                  class="mb-4 block"
                  *ngFor="let item of model.chargePointItems"
                  [price]="item.price"
                  [count]="item.count"
                  [label]="item.label | translate"
                  [description]="item.description | translate"
                  [bottomLabel]="item.bottomLabel | translate"
                ></evsb-price-list-entry>
              </div>
            </evsb-details>
          </evsb-card-body>
        </evsb-smooth-height>
      </evsb-card>
    </div>
  </div>
</div>

<div
  class="
    mt-auto
    px-8
    pt-8
    pb-4
    md:pb-32
    bg-white
    flex flex-col
    lg:flex-row
    md:gap-x-16 md:justify-center md:items-center
    sticky
    bottom-0
  "
  *ngIf="model$ | async as model"
>
  <evsb-primary-button
    class="w-full md:w-auto"
    (click)="onRequestVirtualCheckup()"
    [state]="model.finalInvoiceBtnState"
    [fullWidth]="true"
  >
    {{ 'modules.evcSmallBiz.finalInvoice.footer.primaryButton' | translate }}
  </evsb-primary-button>

  <evsb-primary-text-button (click)="onSendProposalToMailbox()" class="justify-center flex">
    {{ 'modules.evcSmallBiz.finalInvoice.footer.secondaryButton' | translate }}
  </evsb-primary-text-button>
</div>
